import React from 'react'
import { Table, Space, Button, Tooltip, theme } from 'antd'
import { EditOutlined, FileTextOutlined } from '@ant-design/icons'
import { formatDate, getStatusTag } from '../utils/formatters'
import { hexToRGBA } from '../../../../lib/utils'

const AdmissionsTable = ({ admissionsData }) => {
  const { token } = theme.useToken()

  const columns = [
    {
      title: 'Admission ID',
      dataIndex: 'admissionId',
      key: 'admissionId',
      sorter: (a, b) => a.admissionId.localeCompare(b.admissionId)
    },
    {
      title: 'Patient Name',
      dataIndex: 'patientName',
      key: 'patientName',
      sorter: (a, b) => a.patientName.localeCompare(b.patientName)
    },
    {
      title: 'Patient ID',
      dataIndex: 'patientId',
      key: 'patientId'
    },
    {
      title: 'Date of Admission',
      dataIndex: 'dateOfAdmission',
      key: 'dateOfAdmission',
      render: (date) => formatDate(date),
      sorter: (a, b) => new Date(a.dateOfAdmission) - new Date(b.dateOfAdmission)
    },
    {
      title: 'Department',
      dataIndex: 'department',
      key: 'department',
      sorter: (a, b) => a.department.localeCompare(b.department)
    },
    {
      title: 'Attending Physician',
      dataIndex: 'attendingPhysician',
      key: 'attendingPhysician'
    },
    {
      title: 'Room',
      dataIndex: 'roomAssigned',
      key: 'roomAssigned'
    },
    {
      title: 'Status',
      dataIndex: 'admissionStatus',
      key: 'admissionStatus',
      render: (status) => getStatusTag(status)
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space size='small'>
          <Tooltip title='Edit Admission'>
            <Button
              icon={<EditOutlined style={{ color: token.colorWarning }} />}
              size='small'
              style={{
                background: hexToRGBA(token.colorWarning, 0.1),
                borderColor: token.colorWarning,
                color: token.colorWarning
              }}
            />
          </Tooltip>
          <Tooltip title='View Details'>
            <Button
              icon={<FileTextOutlined style={{ color: token.colorPrimary }} />}
              size='small'
              style={{
                background: hexToRGBA(token.colorPrimary, 0.1),
                borderColor: token.colorPrimary,
                color: token.colorPrimary
              }}
            />
          </Tooltip>
        </Space>
      )
    }
  ]

  return <Table columns={columns} dataSource={admissionsData} rowKey='admissionId' pagination={{ pageSize: 10 }} />
}

export default AdmissionsTable
